import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Zap } from "lucide-react";

export default function CTASection({ onOpenQuote }) {
  return (
    <section className="relative py-28 md:py-40 bg-[#040404] overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 opacity-40 carbon-fiber" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(227,27,35,0.15),transparent_60%)]" />

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="relative max-w-[1200px] mx-auto px-6 text-center"
      >
        <div className="inline-flex items-center gap-2 rounded-full border border-[#E31B23]/40 px-4 py-2 mb-8">
          <Zap className="w-4 h-4 text-[#E31B23]" />
          <span className="overline text-neutral-300">Reserve agora</span>
        </div>
        <h2 className="font-display font-black text-5xl md:text-7xl lg:text-8xl leading-[0.92]">
          <span className="text-white">LEVE A </span>
          <span className="neon-red">ADRENALINA</span>
          <br />
          <span className="text-white">PARA SEU </span>
          <span className="text-transparent" style={{ WebkitTextStroke: "1.5px #008CFF" }}>EVENTO.</span>
        </h2>
        <p className="mt-8 max-w-2xl mx-auto text-neutral-300 text-lg">
          Fale com nossa equipe e receba um orçamento personalizado em poucas horas.
        </p>
        <div className="mt-10 flex justify-center">
          <button
            onClick={onOpenQuote}
            className="group inline-flex items-center gap-3 rounded-full bg-[#E31B23] px-10 py-5 text-base md:text-lg font-semibold uppercase tracking-widest text-white glow-red"
            data-testid="cta-quote-btn"
          >
            Solicite um orçamento
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </motion.div>
    </section>
  );
}
